export const global = {
    endpoint_api: window.location.hostname === "localhost" ? "http://localhost:3300/api/v1" : "https://api.exhibition.sytin-museum.ru/api/v1",
    publicUrl: window.location.hostname === "localhost" ? "http://localhost:3301/i/" : "https://exhibition.sytin-museum.ru/i/"
}